__turbopack_context__.v({
  "header": "f0W5wG_header",
  "section": "f0W5wG_section",
  "sub": "f0W5wG_sub",
  "title": "f0W5wG_title",
});
